"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OvernightLocationTextWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var OvernightLocationTextWidget = /** @class */ (function (_super) {
    __extends(OvernightLocationTextWidget, _super);
    function OvernightLocationTextWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.index = _this.getSetting("index", undefined);
        if (_this.index) {
            _this.make = _this.props.interaction.vehicles[_this.index].make;
            _this.model = _this.props.interaction.vehicles[_this.index].model;
            _this.registrationNumber = _this.props.interaction.vehicles[_this.index].registrationNumber;
            _this.address = _this.props.interaction.policyHolder.address.fullAddress;
            _this.postcode = _this.props.interaction.policyHolder.address.postcode;
        }
        else {
            throw Error("Overnight location text widget is missing 'index' setting");
        }
        _this.address = _this.address.substring(0, _this.address.lastIndexOf(",") + 1);
        return _this;
    }
    OvernightLocationTextWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "font-weight-light" },
                "Is the overnight location of ",
                React.createElement("span", { className: "font-weight-bold" },
                    this.capitalize(this.make),
                    ", ",
                    this.capitalize(this.model),
                    " (",
                    this.registrationNumber,
                    ") "),
                "the same as the account holder address ",
                React.createElement("span", { className: "font-weight-bold" },
                    "(",
                    this.capitalize(this.address),
                    " ",
                    this.postcode,
                    ")"),
                "?")));
    };
    OvernightLocationTextWidget.prototype.capitalize = function (text) {
        return text != null ?
            text.toLowerCase().split(' ').map(function (s) { return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase(); }).join(' ') : "";
    };
    return OvernightLocationTextWidget;
}(plugin_journey_1.WidgetBase));
exports.OvernightLocationTextWidget = OvernightLocationTextWidget;
//# sourceMappingURL=OvernightLocationTextWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/falconSelfService/OvernightLocationTextWidget.js
// module id = 3276
// module chunks = 0